import React, { useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { CarouselContext } from './CarouselContext';
import { useDeviceDetect } from '@soluto-private/mx-asurion-ui-react';
export const ScrollIndicatorTrack = styled.div.withConfig({
  displayName: "ScrollIndicatorTrack",
  componentId: "asurion-ui-react__sc-1rp5e5f-0"
})(["position:relative;width:100%;height:0.25rem;background-color:var(--aui-outline-soft);border-radius:999px;overflow:hidden;opacity:", ";transition:opacity 0.25s ease-in-out;"], ({
  $isVisible
}) => $isVisible ? 1 : 0);
export const ScrollIndicatorThumb = styled.div.withConfig({
  displayName: "ScrollIndicatorThumb",
  componentId: "asurion-ui-react__sc-1rp5e5f-1"
})(["position:absolute;top:0;left:0;right:0;bottom:0;background-color:var(--aui-outline);border-radius:999px;transform-origin:left;"]);
export const ScrollIndicator = () => {
  const {
    carouselContainer,
    elementWidth,
    bleedElements,
    isHovering,
    showControls
  } = useContext(CarouselContext);
  const handleRef = useRef(null);
  const {
    isFirefox
  } = useDeviceDetect();
  const bleed = 2 * (parseFloat(elementWidth) * 16 + 16) * bleedElements;
  useEffect(() => {
    const carousel = carouselContainer.current;
    if (!carousel || !handleRef.current) return;
    const listener = () => {
      const totalWidth = carousel.scrollWidth;
      const scrollLeft = carousel.scrollLeft / (totalWidth - bleed);
      const thumbWidth = (carousel.clientWidth - bleed) / (carousel.scrollWidth - bleed);
      let transform = '';
      if (totalWidth < carousel.clientWidth) {
        transform = 'translateX(0%) scaleX(100%)';
      } else {
        transform = [`translateX(${scrollLeft * 100}%)`, `scaleX(${thumbWidth * 100}%)`].join(' ');
      }
      if (isFirefox) {
        // less performant, but removes warning in Firefox
        setTimeout(() => {
          handleRef.current.style.transform = transform;
        }, 0);
      } else {
        handleRef.current.style.transform = transform;
      }
    };
    listener();
    carousel.addEventListener('scroll', listener);
    return () => {
      carousel.removeEventListener('scroll', listener);
    };
  }, [carouselContainer.current, bleed]);
  return /*#__PURE__*/React.createElement(ScrollIndicatorTrack, {
    $isVisible: isHovering || showControls === 'always',
    "data-testid": "carousel-scroll"
  }, /*#__PURE__*/React.createElement(ScrollIndicatorThumb, {
    ref: handleRef
  }));
};